// extracted by mini-css-extract-plugin
export var listItem = "DiscoverySection-module--listItem--a1d3e";
export var sectionBg = "DiscoverySection-module--sectionBg--779d1";